import React, { useState, useEffect } from 'react';
import { Pencil } from 'lucide-react';

const RenamePlayerModal = ({ currentPlayerName, onRename, onCancel }) => {
  const [newPlayerName, setNewPlayerName] = useState(currentPlayerName);

  useEffect(() => {
    setNewPlayerName(currentPlayerName);
  }, [currentPlayerName]);

  if (!currentPlayerName) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-300">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl shadow-2xl p-6 sm:p-8 max-w-sm w-full m-4 text-center">
        <div className="mx-auto bg-sky-500/10 border-4 border-sky-500/20 rounded-full w-20 h-20 flex items-center justify-center mb-6">
          <Pencil className="w-10 h-10 text-sky-400" />
        </div>
        <h2 className="text-2xl font-black text-slate-100 mb-2">Renomear Jogador</h2>
        <p className="text-slate-400 mb-8">
          Digite o novo nome para <strong>{currentPlayerName}</strong>.
        </p>
        <input
          type="text"
          value={newPlayerName}
          onChange={(e) => setNewPlayerName(e.target.value)}
          className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 mb-6 text-white text-center font-semibold"
        />
        <div className="flex gap-3 justify-center">
          <button
            onClick={onCancel}
            className="flex-1 bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold py-3 rounded-xl transition-all"
          >
            Cancelar
          </button>
          <button
            onClick={() => onRename(newPlayerName)}
            className="flex-1 bg-sky-600 hover:bg-sky-500 text-white font-bold py-3 rounded-xl transition-all"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenamePlayerModal;
